import React from "react"
import Animate, { AnimationTypes } from "../Animate/Animate"
import { useTranslation } from "react-i18next"

const featureList = [
  {
    titleKey: "features.digitalOrder.title",
    descKey: "features.digitalOrder.desc",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        ></path>
      </svg>
    ),
    style: { background: "#eff6ff", color: "#2563eb" },
  },
  {
    titleKey: "features.smartStock.title",
    descKey: "features.smartStock.desc",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
        ></path>
      </svg>
    ),
    style: { background: "#ecfdf5", color: "#059669" },
  },
  {
    titleKey: "features.finance.title",
    descKey: "features.finance.desc",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
        ></path>
      </svg>
    ),
    style: { background: "#fffbeb", color: "#d97706" },
  },
  {
    titleKey: "features.qrMenu.title",
    descKey: "features.qrMenu.desc",
    icon: (
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
        ></path>
      </svg>
    ),
    style: { background: "#f5f3ff", color: "#7c3aed" },
  },
]

export const Features: React.FC = () => {
  const { t } = useTranslation("login")

  return (
    <Animate type={AnimationTypes.fadeIn} duration="1.5s">
      <section id="features" className="py-16 lg:py-24 bg-white">
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-black text-slate-900 mb-4">{t("label_resource_title")}</h2>

            <p className="text-slate-500 max-w-[32rem] mx-auto">{t("label_resource_description")}</p>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {featureList.map((e, i) => (
              <div
                key={i}
                className="
                group
                cursor-pointer
                p-6
                bg-slate-50
                rounded-2xl
                transition-all duration-300
                border border-transparent
                hover:bg-white
                hover:border-slate-100
                hover:shadow-xl
                hover:-translate-y-1
              "
              >
                <div
                  className="
                  w-12 h-12
                  rounded-xl
                  flex items-center justify-center
                  mb-5
                  bg-gradient-to-br from-red-500 to-orange-400
                  text-white
                "
                >
                  {e.icon}
                </div>

                <h3 className="text-lg font-bold text-slate-900 mb-2">{t(e.titleKey)}</h3>

                <p className="text-sm text-slate-500 leading-relaxed">{t(e.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Animate>
  )
}

export default Features
